import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatUsageValue } from "@/utils/formatters";
function UsageTimelineChart({ points, usageUnit }) {
    if (points.length === 0) {
        return /*#__PURE__*/ _jsx("div", {
            className: "flex h-[340px] items-center justify-center rounded-xl border border-gray-200 bg-gray-50 text-sm text-gray-500",
            children: "No usage points in this period."
        });
    }
    const width = 980;
    const height = 340;
    const padding = {
        top: 16,
        right: 18,
        bottom: 42,
        left: 54
    };
    const innerWidth = width - padding.left - padding.right;
    const innerHeight = height - padding.top - padding.bottom;
    const maxValue = Math.max(...points.map((point)=>point.usageValue), 1);
    const xForIndex = (index)=>{
        if (points.length === 1) {
            return padding.left + innerWidth / 2;
        }
        return padding.left + index / (points.length - 1) * innerWidth;
    };
    const yForValue = (value)=>{
        return padding.top + innerHeight - Math.max(value, 0) / maxValue * innerHeight;
    };
    const linePath = points.map((point, index)=>`${index === 0 ? "M" : "L"}${xForIndex(index)} ${yForValue(point.usageValue)}`).join(" ");
    const areaPath = `${linePath} L ${xForIndex(points.length - 1)} ${padding.top + innerHeight} L ${xForIndex(0)} ${padding.top + innerHeight} Z`;
    const xTickIndexes = getTickIndexes(points.length);
    return /*#__PURE__*/ _jsx("div", {
        className: "rounded-xl border border-gray-200 bg-white p-3",
        children: /*#__PURE__*/ _jsxs("svg", {
            viewBox: `0 0 ${width} ${height}`,
            className: "h-[340px] w-full",
            children: [
                [
                    0,
                    1,
                    2,
                    3,
                    4
                ].map((row)=>{
                    const ratio = row / 4;
                    const y = padding.top + ratio * innerHeight;
                    const value = maxValue * (1 - ratio);
                    return /*#__PURE__*/ _jsxs("g", {
                        children: [
                            /*#__PURE__*/ _jsx("line", {
                                x1: padding.left,
                                y1: y,
                                x2: padding.left + innerWidth,
                                y2: y,
                                stroke: "#e5e7eb",
                                strokeWidth: "1",
                                strokeDasharray: "4 6"
                            }),
                            /*#__PURE__*/ _jsx("text", {
                                x: padding.left - 10,
                                y: y + 4,
                                textAnchor: "end",
                                fontSize: "11",
                                fill: "#6b7280",
                                children: formatUsageValue(value, usageUnit)
                            })
                        ]
                    }, row);
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: areaPath,
                    fill: "rgba(59, 130, 246, 0.18)"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: linePath,
                    fill: "none",
                    stroke: "#2563eb",
                    strokeWidth: "3"
                }),
                xTickIndexes.map((index)=>{
                    const point = points[index];
                    if (!point) {
                        return null;
                    }
                    return /*#__PURE__*/ _jsx("text", {
                        x: xForIndex(index),
                        y: height - 12,
                        textAnchor: "middle",
                        fontSize: "11",
                        fill: "#6b7280",
                        children: point.label
                    }, index);
                })
            ]
        })
    });
}
function getTickIndexes(pointCount) {
    const xTickStep = Math.max(1, Math.floor(pointCount / 6));
    const xTickIndexes = [];
    for(let index = 0; index < pointCount; index += xTickStep){
        xTickIndexes.push(index);
    }
    if (xTickIndexes[xTickIndexes.length - 1] !== pointCount - 1) {
        xTickIndexes.push(pointCount - 1);
    }
    return xTickIndexes;
}
export { UsageTimelineChart };
